// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2JzU7","file":"styles_file__13JdJ"};